export enum CompanyDetailsActions {
  Toggled = 'toggled',
  PageChange = 'pageChange',
  Edit = 'edit',
  Create = 'create',
}